"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useUserProfilePictureSrc = void 0;
var react_1 = __importDefault(require("react"));
var contexts_1 = require("../contexts");
var RequestProfilePictureBP = __importStar(require("../blueprints/users/request-profile-picture"));
var fetchPromises = {};
function useRequestProfilePicture(userId) {
    var _this = this;
    var BlobCache = react_1["default"].useContext(contexts_1.BlobCacheProviderContext);
    if (BlobCache == null) {
        throw new Error('BlobCacheProviderContext is null');
    }
    var call = BlobCache.client.useMutation(RequestProfilePictureBP).call;
    return react_1["default"].useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, call({ userId: userId })];
                case 1: return [2 /*return*/, (_a.sent()).imageSrc];
            }
        });
    }); }, [call, userId]);
}
var asyncPfpSrcRefreshes = [];
function useUserProfilePictureSrc(userId) {
    var _this = this;
    var _a;
    var BlobCache = react_1["default"].useContext(contexts_1.BlobCacheProviderContext);
    if (BlobCache == null) {
        throw new Error('BlobCacheProviderContext is null');
    }
    var getImageSrcFromServer = useRequestProfilePicture(userId);
    var _b = react_1["default"].useState((_a = BlobCache.memoryCache[userId]) !== null && _a !== void 0 ? _a : null), d = _b[0], s = _b[1];
    react_1["default"].useEffect(function () {
        if (BlobCache == null) {
            throw new Error('BlobCacheProviderContext is null');
        }
        if (BlobCache.memoryCache[userId]) {
            console.debug('useUserProfilePictureSrc: returning from memCache', userId);
            return s(BlobCache.memoryCache[userId]);
        }
        console.debug('useUserProfilePictureSrc: fetching from blob cache', userId);
        var promise = (userId in fetchPromises) && fetchPromises[userId].created.valueOf() > (Date.now() - 5000) ? fetchPromises[userId].promise : new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var result, imageSrc, res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, BlobCache.retrieve(userId)];
                    case 1:
                        result = _a.sent();
                        if (!(result === null)) return [3 /*break*/, 5];
                        console.debug('useUserProfilePictureSrc: fetching from server', userId);
                        return [4 /*yield*/, getImageSrcFromServer()];
                    case 2:
                        imageSrc = _a.sent();
                        console.debug('useUserProfilePictureSrc: fetched from server', userId, imageSrc);
                        if (!(imageSrc != null)) return [3 /*break*/, 4];
                        console.debug('useUserProfilePictureSrc: fetching image', userId, imageSrc);
                        return [4 /*yield*/, BlobCache.get(userId, imageSrc)];
                    case 3:
                        res = _a.sent();
                        console.debug('useUserProfilePictureSrc: fetched image', userId);
                        resolve(res);
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        resolve(result);
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); });
        fetchPromises[userId] = { promise: promise, created: new Date() };
        void promise.then(function (resolved) {
            s(resolved);
            if (resolved != null) {
                BlobCache.memoryCache[userId] = resolved;
            }
            if (!asyncPfpSrcRefreshes.includes(userId)) {
                setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    var imageSrc;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getImageSrcFromServer()];
                            case 1:
                                imageSrc = _a.sent();
                                if (!(imageSrc != null)) return [3 /*break*/, 3];
                                return [4 /*yield*/, BlobCache.get(userId, imageSrc)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }, 1);
            }
        });
    }, [BlobCache, getImageSrcFromServer, userId]);
    return d;
}
exports.useUserProfilePictureSrc = useUserProfilePictureSrc;
